module.exports = __webpack_public_path__ + "static/media/l2_iaq.deb75fb0.png";